import { TOKENSEGURIDADAPI, TOKENSEGURIDADAPIREING } from "../const/backend";

function buildHeaders({ withAuth = false, isJson = true, useReing = false } = {}) {
  const headers = {
    Accept: '*/*',
    'authorizationToken': useReing ? TOKENSEGURIDADAPIREING : TOKENSEGURIDADAPI,
  };

  if (isJson) {
    headers['Content-Type'] = 'application/json; charset=utf-8';
  }

  const token = sessionStorage.getItem("AUTH_TOKEN");
  if (withAuth && token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

async function processResponse(response, { isBlob = false } = {}) {
  if (!response.ok) {
    if (response.status === 401) {
      window.location = '/';
    }
    const errorMessage = await response.text();
    console.error(`Request failed: ${response.status} - ${errorMessage}`);
    throw new Error(`Request failed with ${response.status}`);
  }

  if (response.status === 204) return null;
  // 👇 clave: si la respuesta es binaria, usar blob()
  if (isBlob) {
    return {
      blob: await response.blob(),
      contentType: response.headers.get("content-type"),
    };
  }

  return response.json();
}

async function request(method, url, body = null, options = {}) {
  const headers = buildHeaders(options);

  const response = await fetch(url, {
    method,
    headers,
    body: body
      ? options.isJson === false
        ? body
        : JSON.stringify(body)
      : null,
  });

  return processResponse(response, options);
}

const apiClient = {
  get: (url, options) => request('GET', url, null, { withAuth: true, ...options }),
  post: (url, body, options = {}) => request('POST', url, body, { withAuth: true,  ...options }),
  postData: (url, body) => request('POST', url, body, { withAuth: true, isJson: false }),
  put: (url, body) => request('PUT', url, body, { withAuth: true }),
  delete: (url, body) => request('DELETE', url, body, { withAuth: true }),
};

export default apiClient;
